import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./GongGiPage.css";

import startOverlay from "./resources/honeycombs.png";
import gameoverWinOverlay from "./resources/win.png";
import gameoverLoseOverlay from "./resources/lose.png";
import backgroundImg from "./resources/background_placeholder.jpg";

import questionOneOverlay from "./resources/hand1.jpg";
import questionTwoOverlay from "./resources/hand2.jpg";
import questionThreeOverlay from "./resources/hand3.jpg";
import questionFourOverlay from "./resources/hand4.jpg";

import gameoverImg from "./resources/win_background.png";
import sound from "./resources/sound.png";
import mute from "./resources/mute.png";
import { GAME_OPTIONS_PATH, API_BASE_URL} from "../../../../constants";
import { ReactComponent as CircleSvg } from "../../../../SharedImages/Circle.svg";
import { ReactComponent as SkullSvg } from "../../../../SharedImages/Skull.svg";

import { FIREBASE_AUTH } from "../../../../FirebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { useListeningUnitData, useVocabUnitData, updateProgress } from "../../../../database";

function ScoreView() {
  return (
    <>
      <CircleSvg />
      <SkullSvg />
    </>
  );
}

//features to complete: load different questions set based on location

function GongGiPage() {
  const EASY_QUESTION_RESPONSE_TIME = 100000;
  const MEDIUM_QUESTION_RESPONSE_TIME = 8000;
  const HARD_QUESTION_RESPONSE_TIME = 5000;
  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(FIREBASE_AUTH, (user) => {
      setUser(user);
    });
  });
  const location = useLocation();
  const unit = location.state.unit;
  const category = location.state.category;
  // useState() hook from React used to initialize the component's state object,
  // here useState is called with an object{} having currentOverlay propery initailized with questionOneOverlay, and etc.
  const [state, setState] = useState({
    currentOverlay: questionOneOverlay,
    gameoverOverlay: gameoverWinOverlay,
    radioButton: null,
  });
  // state is a variable that holds the current state. You can access the values in the state by using
  // state.currentOverlay.listening
  // setState is a function that you can call to update the state. When you call setState,
  // you pass in a new object that will update the current state.

  const [remainingTime, setRemainingTime] = useState(0);
  const [questionResponseTime, setQuestionResponseTime] = useState(0);
  const [timerStarted, setTimerStarted] = useState(false);
  const [isQuestionActive, setIsQuestionActive] = useState(true);

  const handleOptionChange = (event) => {
    setState({ ...state, radioButton: event.target.value });
  };

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showCorrectMessage, setCorrectMessage] = useState(false);

  const [audios, setAudios] = useState([]);

  const [currentBackground, setCurrentBackground] = useState(backgroundImg);
  const [currentQuestionId, setCurrentQuestionId] = useState(0);
  const [currIncorrectScore, setCurrIncorrectScore] = useState(0);

  const total_questions = 4;

  const {
    data: listeningData,
    loading,
    error,
  } = useListeningUnitData(unit.unit, unit.textbook);

  const {
    data: vocabData,
    loading: vLoading,
    error: vError,
  } = useVocabUnitData(unit.unit, unit.textbook);

  // Convert listeningData object to sorted array or generate from vocabData
  var listeningDataArr = [];
  if (unit.textbook === "GT_textbook") {
    listeningDataArr = Object.keys(listeningData)
      .map((key) => ({
        ...listeningData[key],
        question_number: parseInt(key)
      }))
      .sort((a, b) => a.question_number - b.question_number);
  } else {
    // 1. Randomly choose 4 words from vocabData
    function getRandomSample(arr, n) {
      const result = [];
      const used = new Set();
      while (result.length < n && used.size < arr.length) {
        const idx = Math.floor(Math.random() * arr.length);
        if (!used.has(idx)) {
          used.add(idx);
          result.push(arr[idx]);
        }
      }
      return result;
    }

    const vocabSample = getRandomSample(vocabData, 4);

    // 2. For each chosen word, options = [the word itself, 3 other random words]
    listeningDataArr = vocabSample.map((word, idx) => {
      // Get 3 other random words (not the word itself)
      const otherWords = vocabData.filter(w => w !== word);
      const randomOthers = getRandomSample(otherWords, 3);
      // Shuffle options
      const options = getRandomSample([word, ...randomOthers], 4);
      return {
        options: options.map(opt => ({ answer: opt.korean, is_correct: opt === word ? 1 : 0 })),
        audio_path: word.audioPath,
        question_number: idx + 1
      };
    });
  }

  const [choices, setChoices] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [dataReady, setDataReady] = useState(false);
  const [gameIsEnded, setGameIsEnded] = useState(false);

  useEffect(() => {
    if (!loading && listeningDataArr.length > 0) {
      console.log("Listening Data Loaded:", listeningDataArr);
      let choices_holder = [];
      let answer_holder = [];
      for (let i = 0; i < total_questions; i++) {
        const q = listeningDataArr[i];
        choices_holder.push(q.options);
        // Find the answer where is_correct === 1
        const correctOption = q.options.find(opt => opt.is_correct === 1);
        answer_holder.push(correctOption ? correctOption.answer : null);
      }
      setChoices(choices_holder);
      setAnswers(answer_holder);
      setDataReady(true);
    }
  }, [loading, listeningData, vocabData]);

  useEffect(() => {
    if (currentQuestionId == 0 && !gameIsEnded) {
      setState({ ...state, currentOverlay: questionOneOverlay });
    }
    if (currentQuestionId == 1 && !gameIsEnded) {
      setState({ ...state, currentOverlay: questionTwoOverlay });
    }
    if (currentQuestionId == 2 && !gameIsEnded) {
      setState({ ...state, currentOverlay: questionThreeOverlay });
    }
    if (currentQuestionId == 3 && !gameIsEnded) {
      setState({ ...state, currentOverlay: questionFourOverlay });
    }
  }, [currentQuestionId, gameIsEnded]);

  // for (let i = 1; i <= total_questions; i++) {
  //   // console.log(question_answer[`question${i}`]);
  //   choices_array.push(question_answer[`question${i}`]);
  // }
  // const answers = getQuestionAnswer(unit.unit)["answers"];

  // The useEffect hook is used in React to perform side effects in function components.
  // Side effects could be data-fetching, subscriptions, manual DOM manipulations, and so on.
  // Here it pre-loads the audio after the inital render to be ready to play as soon as needed
  useEffect(() => {
    if (!loading && listeningDataArr.length > 0) {
      let loadedAudios = [];
      for (let i = 0; i < total_questions; i++) {
        const audioPath = `${API_BASE_URL}${listeningDataArr[i].audio_path}`;
        if (audioPath) {
          loadedAudios.push(new Audio(audioPath));
        } else {
          loadedAudios.push(null);
        }
      }
      setAudios(loadedAudios);
    }
  }, [loading, listeningData, vocabData]);

  const playSound = (number) => {
    if (audios[number]) {
      audios[number].play();
      if (!timerStarted) {
        setTimerStarted(true);
      }
    }
  };

  const toggleBGM = (event) => {
    const audio = document.getElementById("bgm");
    if (!audio) return;
    
    const clickedIconId = event.target.id; // Get the ID of the clicked icon
    const clickedIcon = event.target;

    if (clickedIconId === "sound") {
      audio.play();
    } else if (clickedIconId === "mute") {
      audio.pause();
      audio.currentTime = 0; // Reset audio to start
    }

    // Add 'clicked' class to indicate it's been clicked and then remove it
    clickedIcon.classList.add("clicked");
    setTimeout(() => {
      event.target.classList.remove("clicked");
    }, 200); // Adjust the timeout as needed
  };
  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    // Attach the event listener
    const soundIcon = document.getElementById("sound");
    const muteIcon = document.getElementById("mute");
    
    if (!soundIcon || !muteIcon) return;
    
    soundIcon.addEventListener("click", toggleBGM);
    muteIcon.addEventListener("click", toggleBGM);

    // Cleanup function
    return () => {
      soundIcon.removeEventListener("click", toggleBGM);
      muteIcon.removeEventListener("click", toggleBGM);
    };
  }, []); // Empty dependency array to ensure this runs once on mount ~ rendering

  function openTutorial() {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");
    const gameEl = document.getElementById("game");

    if (pregameEl) pregameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "flex";
    if (postgameEl) postgameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
  }

  function closeTutorial() {
    const pregameEl = document.getElementById("pregame");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");

    if (pregameEl) pregameEl.style.display = "flex";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
  }

  function playAgain() {
    setState({ ...state, radioButton: "" });
    setCurrIncorrectScore(0);
    setCurrentQuestionId(0);
    setCurrentBackground(backgroundImg);
    
    const pregameEl = document.getElementById("pregame");
    const gameEl = document.getElementById("game");
    const postgameEl = document.getElementById("postgame");
    const tutorialEl = document.getElementById("tutorial");
    const winTextEl = document.getElementById("win-text");
    const loseTextEl = document.getElementById("lose-text");
    
    if (pregameEl) pregameEl.style.display = "flex";
    if (gameEl) gameEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (winTextEl) winTextEl.style.display = "none";
    if (loseTextEl) loseTextEl.style.display = "none";
    const helpButtonEl = document.getElementById("gonggi-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "flex";
  }

  function updateResponseTime() {
    const difficultyRadioButton = document.querySelector(
      'input[name="difficulty"]:checked'
    );
    if (!difficultyRadioButton) {
      alert("Please select a difficulty level before starting the game");
      return false;
    }
    
    const difficulty = difficultyRadioButton.value;
    let initialQuestionResponseTime;
    if (difficulty === "easy") {
      initialQuestionResponseTime = EASY_QUESTION_RESPONSE_TIME;
    } else if (difficulty === "medium") {
      initialQuestionResponseTime = MEDIUM_QUESTION_RESPONSE_TIME;
    } else {
      initialQuestionResponseTime = HARD_QUESTION_RESPONSE_TIME;
    }
    setQuestionResponseTime(initialQuestionResponseTime);
    setRemainingTime(initialQuestionResponseTime); //if setRemainingTime(questionResponseTime) -> setRemainingTime(initialQuestionResponseTime), remaining time won't get updated since setQuestionResponseTime(initialQuestionResponseTime) doesn't effect immediately
    return true;
  }
  function startGame() {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    if (isInitializing) {
      return;
    }
    if (!updateResponseTime()) {
      return;
    }
    setCurrentQuestionId(0);
    setCurrIncorrectScore(0);
    setGameIsEnded(false);
    setCurrentBackground(backgroundImg);
    setState({
      ...state,
      gameoverOverlay: gameoverWinOverlay,
      radioButton: "",
    });

    const gameEl = document.getElementById("game");
    const overlayImageEl = document.getElementById("overlay-image");
    const pregameEl = document.getElementById("pregame");
    const postgameEl = document.getElementById("postgame");
    const tutorialEl = document.getElementById("tutorial");
    const scoreViewEl = document.getElementById("score-view");
    
    if (gameEl) gameEl.style.display = "flex";
    if (overlayImageEl) {
      overlayImageEl.style.display = "flex";
      overlayImageEl.classList.add("shakeAnimation");
      overlayImageEl.classList.remove("bounceAnimation");
    }
    if (pregameEl) pregameEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    const helpButtonEl = document.getElementById("gonggi-help-button");
    if (helpButtonEl) helpButtonEl.style.display = "none";

    if (scoreViewEl) {
      for (let i = 0; i < 3; i++) {
        if (scoreViewEl.childNodes[i]) {
          scoreViewEl.childNodes[i].classList.remove("red");
        }
      }
    }
  }

  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    if (currIncorrectScore >= 1) {
      lose();
    }
    if (currIncorrectScore >= 1 && currentQuestionId >= 4) {
      lose();
    }
    if (currentQuestionId >= 4 && currIncorrectScore < 1) {
      win();
    }
  }, [currIncorrectScore, currentQuestionId]);

  function lose() {
    setCurrIncorrectScore(0);
    setCurrentQuestionId(0);
    setGameIsEnded(true);
    setCurrentBackground(gameoverImg);
    setState({
      ...state,
      gameoverOverlay: gameoverLoseOverlay,
      radioButton: "",
    });
    
    const overlayImageEl = document.getElementById("overlay-image");
    const pregameEl = document.getElementById("pregame");
    const gameEl = document.getElementById("game");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");
    const loseTextEl = document.getElementById("lose-text");
    const winTextEl = document.getElementById("win-text");
    
    if (overlayImageEl) overlayImageEl.style.display = "none";
    if (pregameEl) pregameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "flex";
    if (loseTextEl) loseTextEl.style.display = "flex";
    if (winTextEl) winTextEl.style.display = "none";
  }

  function win() {
    setCurrIncorrectScore(0);
    setCurrentQuestionId(0);
    setGameIsEnded(true);
    setCurrentBackground(gameoverImg);
    setState({
      ...state,
      gameoverOverlay: gameoverWinOverlay,
      radioButton: "",
    });
    
    const overlayImageEl = document.getElementById("overlay-image");
    const pregameEl = document.getElementById("pregame");
    const gameEl = document.getElementById("game");
    const tutorialEl = document.getElementById("tutorial");
    const postgameEl = document.getElementById("postgame");
    const winTextEl = document.getElementById("win-text");
    const loseTextEl = document.getElementById("lose-text");
    
    if (overlayImageEl) overlayImageEl.style.display = "none";
    if (pregameEl) pregameEl.style.display = "none";
    if (gameEl) gameEl.style.display = "none";
    if (tutorialEl) tutorialEl.style.display = "none";
    if (postgameEl) postgameEl.style.display = "flex";
    if (winTextEl) winTextEl.style.display = "flex";
    if (loseTextEl) loseTextEl.style.display = "none";
  }

  const [remainingTimeIsZero, setRemainingTimeIsZero] = useState(false);

  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    if (!timerStarted) return; // only start the timer if it's triggered
    if (gameIsEnded || currentQuestionId >= 4) {
      return;
    }
    setRemainingTimeIsZero(false);
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => Math.max(prevTime - 1000, 0));
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [timerStarted, currentQuestionId, dataReady, gameIsEnded]);

  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    if (remainingTime === 0 && timerStarted) {
      setRemainingTimeIsZero(true);
    }
  }, [remainingTime, timerStarted]);

  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    // this hook counting wrong whenever a ongoing timer becomes zero
    if (remainingTimeIsZero === true) {
      wrong_submission();
    }
  }, [remainingTimeIsZero]);

  // Let's thing about some edge cases: in the last question id 3 (correspond toquestion 4) when answered,
  // current question id becomes 4 and will be deteced by a hook which will run win, but since the
  // question id is changed, there is a lingering timer started for the non-existing question 5
  // question 5, and when that timer expires it will trigger wrong submission which then trigger a new timer
  // that's why we can see some component still change after the even when the screen
  // is already directly to the gameover page, luckily we already setup cleanup function previously
  // in the timer to make sure this error doesn't spread when question id is changed again
  // however it's still possible to trigger wrong submission on question 5, despite we have
  // if (currIncorrectScore >= 3) {lose()} where current question id is set to 0, it seems there
  // is a time lap delay, to fix this we add
  // - an additional condition to the thrid hook
  // - an condiation to the first hook
  // update: also found there wrong submission is triggered when swiching units, wrong submission
  // is controlled by submitAnser and this hook in this case should be due to the remainingTime
  // we can add a useEffect hook to track change in location too
  const [isInitializing, setIsInitializing] = useState(false);
  useEffect(() => {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    setIsInitializing(true);
    const initMsgEl = document.getElementById("initialization_msg");
    if (initMsgEl) {
      initMsgEl.style.display = "flex";
    }

    const timer = setTimeout(() => {
      setIsInitializing(false);
      if (initMsgEl) {
        initMsgEl.style.display = "none";
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [unit]);

  function next_question() {
    setCurrentQuestionId(currentQuestionId + 1);
    setRemainingTime(questionResponseTime);
    setTimerStarted(false);
  }

  function correct_submission() {
    if (user) {
      updateProgress(user.email, unit.unit, unit.textbook, "gonggi", true);
    }
    // getProgress(unit.unit)[0].gonggi++;
    setIsQuestionActive(false);
    
    const questionEl = document.getElementById("question");
    const audioBtnEl = document.getElementById("audio-btn");
    const submitBtnEl = document.getElementById("submit-btn");
    const choicesEl = document.getElementById("choices");
    
    if (questionEl) questionEl.style.display = "none";
    if (audioBtnEl) audioBtnEl.style.display = "none";
    if (submitBtnEl) submitBtnEl.style.display = "none";
    if (choicesEl) choicesEl.style.visibility = "hidden";
    
    setCorrectMessage(true);
    setState({ ...state, radioButton: "" });
    
    setTimeout(() => {
      if (questionEl) questionEl.style.display = "flex";
      if (audioBtnEl) audioBtnEl.style.display = "flex";
      if (submitBtnEl) submitBtnEl.style.display = "flex";
      if (choicesEl) choicesEl.style.visibility = "visible";
      
      setCorrectMessage(false);
      setState({ ...state, radioButton: "" });
      
      const overlayImageEl = document.getElementById("overlay-image");
      if (overlayImageEl) {
        overlayImageEl.classList.add("shakeAnimation");
        overlayImageEl.classList.remove("bounceAnimation");
      }
      
      setIsQuestionActive(true);
      next_question();
    }, 1000);
  }
  function wrong_submission() {
    if (user) {
      updateProgress(user.email, unit.unit, unit.textbook, "gonggi", false);
      setIsQuestionActive(false);
    }
    
    const scoreViewEl = document.getElementById("score-view");
    if (scoreViewEl && scoreViewEl.childNodes[currIncorrectScore]) {
      scoreViewEl.childNodes[currIncorrectScore].classList.add("red");
    }
    
    const questionEl = document.getElementById("question");
    const audioBtnEl = document.getElementById("audio-btn");
    const submitBtnEl = document.getElementById("submit-btn");
    const choicesEl = document.getElementById("choices");
    
    if (questionEl) questionEl.style.display = "none";
    if (audioBtnEl) audioBtnEl.style.display = "none";
    if (submitBtnEl) submitBtnEl.style.display = "none";
    if (choicesEl) choicesEl.style.visibility = "hidden";
    
    setShowErrorMessage(true);
    setState({ ...state, radioButton: "" });
    
    setTimeout(() => {
      if (questionEl) questionEl.style.display = "flex";
      if (audioBtnEl) audioBtnEl.style.display = "flex";
      if (submitBtnEl) submitBtnEl.style.display = "flex";
      if (choicesEl) choicesEl.style.visibility = "visible";
      
      setShowErrorMessage(false);
      setState({ ...state, radioButton: "" });
      setCurrIncorrectScore(currIncorrectScore + 1);
      
      const overlayImageEl = document.getElementById("overlay-image");
      if (overlayImageEl) {
        overlayImageEl.classList.add("bounceAnimation");
        overlayImageEl.classList.remove("shakeAnimation");
      }
      
      setIsQuestionActive(true);
      next_question();
    }, 2500);
  }
  function submitAnswer() {
    if (!dataReady) {
      console.log("Game data is still loading...");
      return;
    }
    // Submission Value Acquisition and Modification:
    // Fetches the value inputted in the HTML element with the ID 'answer-input',
    // converts it to lowercase, and stores it in the variable submission.
    const answerRadioButton = document.querySelector(
      'input[name="multi_choice"]:checked'
    );
    if (!answerRadioButton) {
      alert("Please select an answer before submitting");
      return;
    }
    // Stop the timer only for a valid submission.
    setTimerStarted(false);
    setRemainingTime(0);
    const submission = answerRadioButton.value;
    // const submission = document.getElementById('answer-input').value.toLowerCase();
    // document.getElementById('answer-input') This part targets and accesses an HTML element on the webpage.
    // Explanation: document refers to the webpage .getElementById('answer-input') fetches the HTML element that has
    // an id attribute of 'answer-input' and .value retrieves the value/content from the targeted element.

    // This function takes a unit.unit (current location.state) as an argument and
    // returns the corresponding progress data from the DummyProgress object.
    // The DummyProgress object is a dictionary (not Primitive Data Types so in JavaScript terms, an object)
    // where each key represents a unit number,
    // and each value is a list of dictionaries that used track the progress of different mini-games within each unit.
    // in that list of dictionaries, [1] represent total attempts, [0] represent correct attempts

    if (submission === answers[currentQuestionId]) {
      correct_submission();
    } else {
      wrong_submission();
    }
  }

  if (loading || !dataReady) {
    return (
      <div className="loading-screen">
        <h2>Loading audio questions...</h2>
      </div>
    );
  }

  return (
    <div id="sugar-honeycombs-full-container">
      <img id="background" src={currentBackground} alt="SugarHoneycombs" />
      <img id="overlay-image" src={state.currentOverlay} alt="Overlay" />
      <img id="sound" src={sound} alt="Sound Icon" />
      <img id="mute" src={mute} alt="Mute Icon" />
      {/* <img id="back" src={back} alt="Back Icon" /> */}
      <audio
        id="bgm"
        src="/audios/BGM_Yummy_Flavor_모두의 브금.mp3"
        preload="auto"
        hidden
      ></audio>
      <div id="empty-div"></div>
      <div id="sugar-honeycombs-container">
        <div id="header">
          <button
            type="button"
            id="gonggi-help-button"
            className="gonggi-help-button"
            onClick={openTutorial}
            aria-label="Open Gong Gi tutorial"
          >
            ?
          </button>
          <h1 className="gonggi-unit-title">{unit.name}</h1>
          <div id="pregame">
            <div id="settings">
              <b>Difficulty Level:</b>
              <input
                type="radio"
                id="easy"
                name="difficulty"
                value="easy"
              ></input>
              <label for="easy">Easy</label>
              <input
                type="radio"
                id="medium"
                name="difficulty"
                value="medium"
              ></input>
              <label for="medium">Medium</label>
              <input
                type="radio"
                id="hard"
                name="difficulty"
                value="hard"
              ></input>
              <label for="hard">Hard</label>
              <br></br>
            </div>
            <button className="btn btn-primary" onClick={startGame}>
              Start Game
            </button>
          </div>
          <div id="game">
            <div id="score-view">
              <ScoreView />
            </div>
            <br />
            <div id="question">
              <h2>Choose an option according to the audio.</h2>
            </div>
            <div id="choices">
              {currentQuestionId <= 3 // blank page most likely due to conditional rendering
                ? choices[currentQuestionId].map(function (choice, i) {
                    return (
                      <div
                        key={i}
                        style={{ display: "block", marginBottom: "20px" }}
                      >
                        <input
                          type="radio"
                          name="multi_choice"
                          value={choice.answer}
                          id={`choice-${i}`}
                          checked={state.radioButton === choice.answer}
                          onChange={handleOptionChange}
                        />
                        <label htmlFor={`choice-${i}`}>{choice.answer}</label>
                      </div>
                    );
                  })
                : currIncorrectScore < 1 && win()}
            </div>

            <div id="answer">
              {/* Conditional Rendering within JSX: display error message if showErrorMessage is true */}
              {showErrorMessage && (
                <div id="error">
                  <h2 id="error-message">Incorrect answer!</h2>
                  <h3 id="error-message">
                    The right answer is : {answers[currentQuestionId]}
                  </h3>
                </div>
              )}
              {showCorrectMessage && (
                <div id="correct">
                  <h2 id="correct-message">Correct answer! Good job!</h2>
                </div>
              )}
              <button
                id="submit-btn"
                className="btn btn-primary"
                onClick={submitAnswer}
              >
                Submit
              </button>
            </div>
            <div>
              {/* Generally, onClick={playSound}: assigns the function to be called when the button is clicked
                            onClick={playSound()}: call immediately. But in our case, our playSound function have parameter 
                            so use onClick={() => playSound(1)}
                            */}
              <button
                id="audio-btn"
                className="btn btn-primary"
                onClick={() => playSound(currentQuestionId)}
              >
                Play audio
              </button>
            </div>
            {isQuestionActive && (
              <div id="timer-bar">
                <progress
                  value={questionResponseTime - remainingTime}
                  max={questionResponseTime}
                ></progress>
              </div>
            )}
          </div>
          <div id="postgame">
            <h2 id="win-text">"Congratulations, you win"</h2>
            <h2 id="lose-text">"You lose, better luck next time!"</h2>
            <img
              id="gameover-overlay"
              src={state.gameoverOverlay}
              alt="Gameover"
            />
            <button className="btn btn-primary" onClick={playAgain}>
              Play Again
            </button>
          </div>
          <div id="tutorial">
          <h2>Gong Gi Tutorial</h2>
          <p>
            <b>Goal:</b> Clear all 4 listening questions in a row to complete
            the round.
          </p>
          <p>
            <b>How to Play:</b>
            <br />
            1. Choose a difficulty level before starting.
            <br />
            2. Play the audio prompt for the current question.
            <br />
            3. Select the answer that matches what you hear.
            <br />
            4. Submit your choice and move to the next hand position.
          </p>
          <p>
            <b>Rules:</b>
            <br />
            You must answer every question correctly.
            <br />
            One wrong answer ends the round immediately.
            <br />
            Winning means finishing all 4 questions without making a mistake.
          </p>
          <p>
            <b>Difficulty:</b>
            <br />
            Easy gives the longest response time.
            <br />
            Medium shortens the timer.
            <br />
            Hard gives the shortest time, so replay audio quickly when needed.
          </p>
            <button className="btn btn-primary" onClick={closeTutorial}>
              Back to Game Setup
            </button>
          </div>
        </div>
        <Link
          to={GAME_OPTIONS_PATH}
          state={{ unit: unit, category: category }}
          className="game-options-back-link"
        >
          <button className="btn btn-back game-options-back-button">{"Back"}</button>
        </Link>
      </div>
    </div>
  );
}

// this line at the end is exporting this component, making it available for being imported in another file like App.js
export default GongGiPage;
